"use strict";
exports.__esModule = true;
exports.ZERO_BALANCE_SURVEY = exports.ZERO_BALANCE_DISPOSITION_HANDLING_EXPERIMENT = void 0;
exports.ZERO_BALANCE_DISPOSITION_HANDLING_EXPERIMENT = {
    LANDING_SCREEN: {
        MAIN_TEXT: 'We detected your rent bill is $0',
        SUB_TEXT: 'Tell us if anything changed, like if you moved or if your property had a change in management.',
        HELP_CTA: 'View Details'
    },
    SUPPORT_OR_RELINK_SCREEN: {
        MAIN_TEXT: 'We need to restore the connection to your property',
        SUB_TEXT: 'Please contact support so we can help you restore the connection to your property. You can also try to relink yourself. Make sure the address on file is correct before proceeding.',
        PRIMARY_BUTTON_TEXT: 'Contact support',
        SECONDARY_BUTTON_TEXT: 'Relink property'
    },
    OVERWRITE_SCREEN: {
        MAIN_TEXT: 'How much rent should we pay to your property?',
        SUB_TEXT: "We need to know how much you'd like Flex to pay to continue your service.",
        MORE_TEXT: "If you no longer want Flex to pay this month's bill, enter $0.00.",
        MONEY_INPUT_LABEL: 'Rent payment amount',
        CTA_TEXT: 'Update payment amount'
    }
};
exports.ZERO_BALANCE_SURVEY = {
    HEADLINE: 'Do you know why your rent bill is showing as $0?',
    OPTIONS: [
        {
            text: 'I moved and need to update my address',
            value: 'addressChanged'
        },
        {
            text: 'My property had a change in management',
            value: 'propertyManagementChanged'
        },
        {
            text: 'The website I use to pay rent has changed',
            value: 'rentPaymentWebsiteChanged'
        },
        {
            text: 'My property has not posted my rent bill yet',
            value: 'billNotPosted'
        },
        { text: "I'm not sure", value: 'doesNotKnow' },
    ]
};
